
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getClaimDJ,getClaimDeductionInfo,putPurchaseOrder } from "@/api/credit-note";
import VXETable from "vxe-table";

import { addInquirySheet } from "@/api/inquiry";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer,
} from "@/api/customer";
@Component({
  name: "CreateClaim",
})
// getClaimDJ -- 索赔金额抵扣-获取索赔单据
// getClaimDeductionInfo -- 索赔金额抵扣-索赔单据抵扣信息
// putPurchaseOrder -- 索赔单金额抵扣
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: "codesType"}) private codesType: any;
  @Prop({ default: "" }) private supplierId: string;
  @Prop({ default: [] }) private claimList: any;
  private claimDJList = [] as any;
  private form = {
    customerId: null,
    company: null,
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public props = { multiple: true,emitPath:false };
  private ChangeClaimCode = [] as any;
  public tableCol = [
    {
      label: "索赔单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "类型",
      prop: "deductionMethod",
      key: "deductionMethod",
      show: true,
      disabled: false
    },
    {
      label: "产品",
      prop: "claimProducts",
      key: "claimProducts",
      show: true,
      disabled: false
    },
    {
      label: "生成时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false
    },
    {
      label: "索赔金额",
      prop: "claimAmount",
      key: "claimAmount",
      show: true,
      disabled: false
    },
    {
      label: "预定抵扣",
      prop: "reservationDeduction",
      key: "reservationDeduction",
      show: true,
      disabled: false,
    },
    {
      label: "未抵扣金额",
      prop: "unDeductedAmount",
      key: "unDeductedAmount",
      show: true,
      disabled: false
    },
    {
      label: "抵扣金额",
      prop: "deductionAmount",
      key: "deductionAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2
    },
    {
      label: "备注",
      prop: "deductionRemark",
      key: "deductionRemark",
      show: true,
      disabled: false,
      type: "textarea",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        // { name: "编辑", code: '', click: "handleEdit" },
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;

  public tableCol1 = [
    {
      label: "索赔单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "类型",
      prop: "deductionMethod",
      key: "deductionMethod",
      show: true,
      disabled: false
    },
    {
      label: "产品",
      prop: "claimProducts",
      key: "claimProducts",
      show: true,
      disabled: false
    },
    {
      label: "生成时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false
    },
    {
      label: "索赔金额",
      prop: "claimAmount",
      key: "claimAmount",
      show: true,
      disabled: false
    },
    {
      label: "预定抵扣",
      prop: "reservationDeduction",
      key: "reservationDeduction",
      show: true,
      disabled: false,
    },
    {
      label: "未抵扣金额",
      prop: "unDeductedAmount",
      key: "unDeductedAmount",
      show: true,
      disabled: false
    },
    {
      label: "抵扣金额",
      prop: "deductionAmount",
      key: "deductionAmount",
      show: true,
      disabled: true,
      type: "inputNumber",
      precision: 2
    },
    {
      label: "备注",
      prop: "deductionRemark",
      key: "deductionRemark",
      show: true,
      disabled: true,
      type: "textarea",
    }
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ];
  @Watch("supplierId", { immediate: true })
  private watchData() {
    if(this.supplierId) {
      this.getClaimDJ()
    }
  }
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.addInquirySheet();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async getClaimDJ() {
    let params = {
      type: this.codesType,
      supplierId: this.supplierId
    }
    const res:any = await getClaimDJ(params)
    this.claimDJList = res
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }
  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);
  }
  private async handleAdd() {
    if(this.ChangeClaimCode.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择类型",
        type: "error",
        duration: 2000,
      });
      return
    }
    let filterData = this.table.list.filter(row => this.ChangeClaimCode.includes(row.code));
    if(filterData.length > 0) {
      this.$notify({
        title: "提示",
        message: filterData.map(function(v){return v.code}) + "已在列表中",
        type: "error",
        duration: 2000,
      });
      return
    }
    let params = {
      codes: this.ChangeClaimCode
    }
    const res:any = await getClaimDeductionInfo(params)
    this.table.list = [...this.table.list,...res];
    this.ChangeClaimCode = [];
    (this.$refs['casse'] as any).$refs.panel.checkedValue = [];
    (this.$refs['casse'] as any).$refs.panel.clearCheckedNodes();
    (this.$refs['casse'] as any).$refs.panel.activePath = [];
    // table.list 新增一条记录
    // this.table.list.push({
    //   type: "",
    //   amount: "",
    //   remark: "",
    // });
  }

  private handleChangeClaim(value) {
    // console.log('value',value);
    if(!value.length) return
    this.ChangeClaimCode = value
    // getClaimDeductionInfo
  }
  // 新建询价单
  private async addInquirySheet() {
    const { customerId, company } = this.form;
    let params = {
      customerId,
      company,
    };
    try {
      await addInquirySheet(params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
}
